import { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { SEO } from "utils/helmet/components/SEO";
import Tournament from "components/organisms/Tournament";
import { useTournamentsStore } from "stores/tournaments";
import { api } from "utils/hostname";
import url from "url/index";
import { useLocalizationStore } from "stores/localization";
import * as gameSelectors from "../../redux/game/selectors";
import * as authSelectors from "../../redux/auth/selectors";

const request = () => api(true, true).get(url.config.api.tournament.root);

const TournamentContainer = () => {
  const games = useSelector(gameSelectors.games);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { tournament, tournaments, setTournaments, setTournament } =
    useTournamentsStore();
  const lang = useLocalizationStore((state) => state.language);
  const { id } = useParams();

  const { data } = useQuery({
    queryKey: ["tournaments"],
    queryFn: request,
    enabled: !tournaments,
  });

  // useCallback to memoize the effect and avoid duplicate calls
  const setTournamentData = useCallback(() => {
    if (data && !tournaments) {
      setTournaments(data.data.tournaments);
    }

    if (tournaments) {
      const selectedTournament = tournaments.find(
        (t) => t.id.toString() === id,
      );
      if (selectedTournament) {
        setTournament(selectedTournament);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, tournaments, tournament, id, setTournaments, setTournament]);

  useEffect(() => {
    setTournamentData();
    return () => {
      setTournament(null);
    };
  }, [setTournament, setTournamentData]);

  if (!tournaments || !tournament) {
    return null;
  }

  return (
    <>
      <SEO pathname={`/${url.config.tournament.root}/${id}`} />
      <Tournament
        games={games}
        key={tournament.id}
        tournament={tournament}
        lang={lang ?? "EN"}
        isAuthenticated={isAuthenticated}
      />
    </>
  );
};

export default TournamentContainer;
